module.exports = __webpack_public_path__ + "img/banner2.1494845b.jpg";